import React from "react";
import styled from "styled-components";
import { Rect, Triangle } from "@sonder/ui/source/styled/fragments/SVGShapes";
import { colors } from "@sonder/ui/source/styled/theme";

interface CalendarDayProps {
  className?: string;
  isCheckedOutToday?: boolean;
  isCheckedInToday?: boolean;
  isOccupiedAllDay?: boolean;
  title?: string;
}

interface StyledCalendarDay {
  primaryColor?: string;
  secondaryColor?: string;
}

const StyledCalendarDay = styled.span<StyledCalendarDay>`
  height: 26px;
  display: inline-block;
  position: relative;
  width: 26px;

  svg {
    position: absolute;
    height: 100%;
    width: 100%;

    rect {
      fill: ${props => props.primaryColor};
      stroke: ${props => props.primaryColor};
    }
  }

  svg:first-child {
    left: 0;
    top: 0;

    path {
      fill: ${props => props.primaryColor};
      stroke: ${props => props.primaryColor};
    }
  }

  svg:last-child {
    bottom: 0;
    right: 0;
    transform: rotate(180deg);

    path {
      fill: ${props => props.secondaryColor};
      stroke: ${props => props.secondaryColor};
    }
  }
`;

export function CalendarDay({
  className,
  isCheckedInToday,
  isCheckedOutToday,
  isOccupiedAllDay,
  title,
}: CalendarDayProps) {
  let primaryColor = colors.greenLight;
  let secondaryColor = colors.greenLight;

  const fullyVacant =
    !isCheckedInToday && !isCheckedOutToday && !isOccupiedAllDay;
  const isFull = fullyVacant || isOccupiedAllDay;

  if (isFull) {
    if (isOccupiedAllDay) primaryColor = colors.redLight;
  } else {
    if (isCheckedInToday) secondaryColor = colors.redLight;

    if (isCheckedOutToday) primaryColor = colors.redLight;
  }

  const contents = isFull ? (
    <Rect />
  ) : (
    <>
      <Triangle />
      <Triangle />
    </>
  );

  return (
    <StyledCalendarDay
      className={className}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      title={title}
    >
      {contents}
    </StyledCalendarDay>
  );
}
